let store = {};
export const setGlobalStore = (storeIntance) => {
    store = storeIntance;
};
export const getGlobalStore = () => store;
